import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonServiceService } from '../services/common-service.service';
@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.css']
})
export class InfoPanelComponent implements OnInit {
  username: string="";
  constructor(private router: Router,
    private service: CommonServiceService,) { }

  ngOnInit(){
    this.username = JSON.parse(localStorage.getItem('merchantDetails')).name;
  }
  goToCompleteKYCPage(){
    this.router.navigateByUrl('/business-detail');
  }
}
